import { render, staticRenderFns } from "./ConfigAccessUsersTab.vue?vue&type=template&id=3b593152&scoped=true"
import script from "./ConfigAccessUsersTab.vue?vue&type=script&lang=js"
export * from "./ConfigAccessUsersTab.vue?vue&type=script&lang=js"
import style0 from "./ConfigAccessUsersTab.vue?vue&type=style&index=0&id=3b593152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b593152",
  null
  
)

export default component.exports